import React from 'react';
import { Link } from 'react-router-dom';
import heroVideo from '../../assets/videos/video.mp4';

const HeroSection = () => {
  return (
    <section className="relative h-[100vh] w-full overflow-hidden -mt-[73px]">
      {/* Background Video */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute top-0 left-0 w-full h-full object-cover"
      >
        <source src={heroVideo} type="video/mp4" />
      </video>
      
      {/* Overlay */}
      <div className="absolute inset-0 bg-navy/70"></div>
      
      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center text-white px-4 sm:px-6">
        <p className="section-kicker text-teal/95 mb-2 drop-shadow-sm">Maritime · Logistics · Global trade</p>
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-[3.5rem] font-bold tracking-tight mb-5 max-w-4xl leading-tight drop-shadow-md">
          Welcome to{' '}
          <span className="text-teal">Infinity Enterprises</span>
        </h1>
        <p className="text-lg md:text-xl text-white/90 max-w-2xl mb-10 leading-relaxed">
          Your trusted partner for compliant ship supply, export programs, and dependable logistics.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
          <Link to="/services" className="btn-primary px-8 py-3.5 text-base shadow-lg shadow-black/10">
            Explore Our Services
          </Link>
          <Link to="/contact" className="btn-secondary px-8 py-3.5 text-base">
            Contact Us
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;